module.exports = __webpack_public_path__ + "img/espirito_santo.1493d668.jpg";